import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//antd
import { Col, DatePicker, Form, Input, Row, Select } from "antd";
import moment from "moment";

import { getValidaDatos } from "../../../redux/aspirante/aspiranteDucks";
//utils & components
import { Label, TooltipImg } from "../../../utils";
import { AlertGeneric, disabledDate18, getFecha } from "../../../utils";
import { valueUpperCase, titleCase, formatFecha } from "../../../utils";
import { RegistroCorreo } from "./";

import * as uiText from "../../../utils";
import * as consts from "../../../utils";
import * as rules from "../../../utils";

//Imgs
import rfcImagen from "../../../assets/img/home/RFCexplica.svg";
import fuarImagen from "../../../assets/img/home/FUAR.png";

//Props de inputs
const props = {
  autoComplete: "off",
};

/**
 * Componente que permite registrar los datos personales de un aspirante.
 * @param {boolean} isRegistro - valida si esta en la pantalla de registro o consulta
 * @param {object} form - Hooks del useForm
 * @return {JSX.Element}
 */
export const DatosPersonales = ({ isRegistro, form }) => {
  const dispatch = useDispatch();
  const { getFieldValue, setFieldsValue } = form;
  const [datos, setDatos] = useState({});

  //State-redux
  const { estadosExt } = useSelector((state) => state.catalogos);
  const { isConsulta } = useSelector((state) => state.aspirante.consulta);
  const { aspiranteById } = useSelector((state) => state.aspirante);

  const { isValidRfc, mensaje } = useSelector((state) => state.aspirante.rfc);
  const { isValidCurp, mensaje: mensajeCurp } = useSelector(
    (state) => state.aspirante.curp
  );
  const { isValidClave, mensaje: mensajeClave } = useSelector(
    (state) => state.aspirante.clave
  );
  //Si el sistema esta en modo pruebas
  const { isPruebas } = useSelector((state) => state.catalogos);

  /**
   * Función que recupera el texto del estado a partir del id
   * @param {number} id
   * @return {string} El nombre del estado
   */
  const getTextEstado = (id) =>
    estadosExt.find(({ idEstado }) => idEstado === +id)?.nombreEstado;

  /**
   * Función que recupera el id del estado a partir de la abreviatura
   * @param {string} abreviatura
   * @return {number} El id del estado
   */
  const getIdEstado = (abrev) =>
    estadosExt.find(({ abreviatura }) => abreviatura === abrev)?.idEstado;

  /**
   * Función que recupera el texto del sexo a partir de la inicial
   * @param {string} sexo
   * @return {string} Hombre ó Mujer
   */
  const getTextSexo = (sexo) => (sexo === "H" ? "Hombre" : "Mujer");

  /**
   *Función que extrae los datos del curp y obtiene
   * el sexo, fecha y estado de nacimiento
   * @param {*} event
   */
  const extraerDatosCurp = (event) => {
    // let regex = /^[A-Z]{4}[0-9]{6}[H|M][A-Z]{5}[A-Z0-9][0-9]$/i;
    let curp = event.target.value;
    if (consts.REGEX_CURP.test(curp)) {
      let m = curp.match(/^\w{4}(\w{2})(\w{2})(\w{2})(\w{1})(\w{2})/);
      let fecha = getFecha(curp);      
      //Sexo
      let sexo = m[4];
      //Entidad de nacimiento
      let entidad = m[5];
      //Se obtiene el idEstado a partir de la abreviatura
      let idEstadoNac = getIdEstado(entidad);
      //Se valida
      idEstadoNac = idEstadoNac ? String(idEstadoNac) : undefined;
      //Se mandan a cargar los campos
      asignarValores(fecha, idEstadoNac, sexo.toUpperCase());
    }
    //Valida si existe el curp al momento de registrar al aspirante
    if (consts.REGEX_CURP.test(curp) && isRegistro && !isPruebas) {
      dispatch(getValidaDatos(2, curp));
    }
  };
  /**
   * Función que carga automaticamente los campos: Fecha nacimiento, estado de nacimiento y sexo una vez capturado el curp
   * @param {Date} fecha
   * @param {string} idEstadoNac
   * @param {string} sexo
   */
  const asignarValores = (fecha, idEstadoNac, sexo) => {
    //Se valida fecha de nacimiento
    if (fecha.isValid()) {
      setFieldsValue({ fechaNacimiento: fecha });
      //Se convierte la fecha a string
      const fechaString = formatFecha(fecha, consts.DATE_FORMAT);
      //Se almacena en el hook para validar si el aspirante realiza un cambio
      setDatos((datos) => ({
        ...datos,
        fecha: fechaString, //Fecha asignada desde el curp
        fechaCopia: fechaString,
      }));
    }
    //Sexo
    if (sexo) {
      setFieldsValue({ sexo });
      //Se almacena en el hook para validar si el aspirante realiza un cambio en el sexo
      setDatos((datos) => ({ ...datos, sexo, sexoCopia: sexo }));
    }

    if (idEstadoNac) {
      setFieldsValue({ idEstadoNac });
      //Se almacena en el hook para validar si el aspirante realiza un cambio en el estado de nacimiento
      setDatos((datos) => ({ ...datos, idEstadoNac, idEstado: idEstadoNac }));
    }
  };

  //Valida el RFC
  const onChangeRfc = () => {
    if (isRegistro && !isPruebas) {
      const rfc = getFieldValue("rfc");
      if (consts.REGEX_RFC.test(rfc) && rfc.length > 9) {
        dispatch(getValidaDatos(1, rfc));
      }
    }
  };

  //Valida la clave
  const onChangeClave = () => {
    if (isRegistro && !isPruebas) {
      const claveElector = getFieldValue("claveElector");
      if (consts.REGEX_CLAVE.test(claveElector)) {
        dispatch(getValidaDatos(3, claveElector));
      }
    }
  };

  //------------------------------------------------------------------------------------------------
  const onChangeFecha = (date, dateString) => {
    isRegistro &&
      setDatos((validar) => ({ ...validar, fechaCopia: dateString }));
  };

  const onChangeEstadoNac = (value) => {
    isRegistro &&
      setDatos((validar) => ({ ...validar, idEstado: String(value) }));
  };
  const onChangeSexo = (value) => {
    isRegistro && setDatos((validar) => ({ ...validar, sexoCopia: value }));
  };

  return (
    <>
      {/* //Si solo si es registro publico se muestra este componente          */}
      {isRegistro && <RegistroCorreo form={form} />}

      <Row gutter={24}>
        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Form.Item
            label={
              <Label label={"Nombre(s)"} isConsulta={isConsulta} isRequired />
            }
            name="nombre"
            rules={rules.TXT_LETRAS_REQ}
            initialValue={aspiranteById.nombre}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.nombre}</div>
            ) : (
              <Input
                // placeholder="Nombre(s)"
                maxLength={50}
                {...props}
                onInput={(e) => (e.target.value = titleCase(e.target.value))}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Form.Item
            label={
              <Label
                label={"Primer apellido"}
                isConsulta={isConsulta}
                isRequired
              />
            }
            name="apePaterno"
            rules={rules.TXT_LETRAS_REQ}
            initialValue={aspiranteById.apePaterno}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.apePaterno}</div>
            ) : (
              <Input
                maxLength={consts.MAX_NOMBRES}
                {...props}
                onInput={(e) => (e.target.value = titleCase(e.target.value))}
              />
            )}
          </Form.Item>
        </Col>

        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Form.Item
            label={<Label label={"Segundo apellido"} isConsulta={isConsulta} />}
            name={"apeMaterno"}
            rules={rules.TXT_LETRAS}
            initialValue={aspiranteById.apeMaterno}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.apeMaterno}</div>
            ) : (
              <Input
                maxLength={consts.MAX_NOMBRES}
                {...props}
                onInput={(e) => (e.target.value = titleCase(e.target.value))}
              />
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Form.Item
            label={
              <TooltipImg img={rfcImagen} alt="rfc" estilo="img-rfc">
                <Label
                  label={"RFC con homoclave"}
                  isConsulta={isConsulta}
                  isRequired
                />
              </TooltipImg>
            }
            name="rfc"
            getValueFromEvent={valueUpperCase}
            rules={rules.RFC}
            initialValue={aspiranteById.rfc}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.rfc}</div>
            ) : (
              <Input
                onChange={onChangeRfc}
                maxLength={consts.MAX_RFC}
                {...props}
              />
            )}
          </Form.Item>
        </Col>

        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Form.Item
            label={
              <>
                <Label label={"CURP"} isConsulta={isConsulta} isRequired />
                &nbsp;&nbsp;
                {/* {isRegistro && ( */}
                {!isConsulta && (
                  <a
                    href="https://www.gob.mx/curp/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link"
                  >
                    Consultar CURP
                  </a>
                )}
              </>
            }
            getValueFromEvent={valueUpperCase}
            name="curp"
            rules={rules.CURP}
            initialValue={aspiranteById.curp}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.curp}</div>
            ) : (
              <Input
                maxLength={consts.MAX_CURP}
                onChange={extraerDatosCurp}
                {...props}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Form.Item
            label={
              <TooltipImg img={fuarImagen} alt="clave" estilo="clave-img">
                <Label
                  label={"Clave de elector o Comprobante de trámite"}
                  isConsulta={isConsulta}
                  isRequired
                />
              </TooltipImg>
            }
            name="claveElector"
            getValueFromEvent={valueUpperCase}
            rules={rules.CLAVE_ELECTOR_FUAR}
            initialValue={aspiranteById.claveElector}
          >
            {isConsulta ? (
              <div className="consulta-div">{aspiranteById.claveElector}</div>
            ) : (
              <Input
                maxLength={consts.MAX_CLAVE_FUAR}
                onChange={onChangeClave}
                {...props}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
      {/* --------- Validar Datos RFC, CURP y Clave de Elector ---------------------- */}
      {!isValidRfc && <AlertGeneric type="error" message={mensaje} />}
      {!isValidCurp && <AlertGeneric type="error" message={mensajeCurp} />}
      {!isValidClave && <AlertGeneric type="error" message={mensajeClave} />}

      <Row gutter={24}>
        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Form.Item
            label={
              <Label
                label={"Fecha de nacimiento"}
                isConsulta={isConsulta}
                isRequired
              />
            }
            name="fechaNacimiento"
            rules={rules.FECHA_NACIMIENTO}
            initialValue={
              aspiranteById.fechaNacimiento &&
              moment.utc(aspiranteById.fechaNacimiento)
            }
          >
            {isConsulta ? (
              <div className="consulta-div">
                {moment(aspiranteById.fechaNacimiento)
                  .format(consts.DATE_FORMAT)
                  .toString()}
              </div>
            ) : (
              <DatePicker
                format={consts.DATE_FORMAT}
                disabledDate={disabledDate18}
                defaultPickerValue={moment().add(-18, "years")}
                onChange={onChangeFecha}
              />
            )}
          </Form.Item>
        </Col>

        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Form.Item
            label={
              <Label
                label={"Lugar de nacimiento"}
                isConsulta={isConsulta}
                isRequired
              />
            }
            name="idEstadoNac"
            rules={rules.REQUERIDO}
            initialValue={
              aspiranteById.idEstadoNac && String(aspiranteById.idEstadoNac)
            }
          >
            {isConsulta ? (
              <div className="consulta-div">
                {getTextEstado(aspiranteById.idEstadoNac)}
              </div>
            ) : (
              <Select
                showSearch
                allowClear
                optionFilterProp="children"
                placeholder={uiText.SELECCIONA_OPCION}
                onChange={onChangeEstadoNac}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {estadosExt.map((item) => (
                  <Select.Option key={item.idEstado}>
                    {item.nombreEstado}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Form.Item
            // label={<Label label={"Sexo"} isConsulta={isConsulta} isRequired />}
            label={
              <TooltipImg text={uiText.INFO_SEXO_CLAVE}>
                <Label label={"Sexo"} isConsulta={isConsulta} isRequired />
              </TooltipImg>
            }
            name="sexo"
            rules={rules.REQUERIDO}
            initialValue={aspiranteById.sexo}
          >
            {isConsulta ? (
              <div className="consulta-div">
                {getTextSexo(aspiranteById.sexo)}
              </div>
            ) : (
              <Select
                placeholder={uiText.SELECCIONA_OPCION}
                onChange={onChangeSexo}
              >
                <Select.Option key="H">Hombre</Select.Option>
                <Select.Option key="M">Mujer</Select.Option>
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>

      {consts.REGEX_CURP.test(getFieldValue("curp")) && isRegistro && (
        <>
          {datos.fecha !== datos.fechaCopia && (
            <AlertGeneric type="warning" message={uiText.INFO_WARNING} />
          )}
          {datos.idEstadoNac !== datos.idEstado && (
            <AlertGeneric type="warning" message={uiText.INFO_WARNING} />
          )}
          {datos.sexo !== datos.sexoCopia && (
            <AlertGeneric type="warning" message={uiText.INFO_WARNING} />
          )}
        </>
      )}
    </>
  );
};
